import { render } from "./boletim-notas.vue?vue&type=template&id=e29a4db8"
import script from "./boletim-notas.vue?vue&type=script&lang=js"
export * from "./boletim-notas.vue?vue&type=script&lang=js"

import "./boletim-notas.vue?vue&type=style&index=0&id=e29a4db8&lang=css"
import "./boletim-notas.vue?vue&type=style&index=1&id=e29a4db8&lang=css"
import "./boletim-notas.vue?vue&type=style&index=2&id=e29a4db8&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__